module.exports = __webpack_public_path__ + "img/P1000911.2949f2cc.jpg";